module.exports = __webpack_public_path__ + "img/topUp-banner.3723a3d7.png";